import React from 'react'
import { statsContent } from './content'
import { Wrapper, Stat } from './styles'

import People from '../../static/images/people-small.svg'
import SIM from '../../static/images/sim-small.svg'

const DataRolloverStats = () => (
  <Wrapper>
    <Stat fullWidth data-testid="money-back-stat">
      {statsContent.firstStat}
    </Stat>

    <Stat hasImage data-testid="image-src-second">
      <p data-testid="unused-data-stat">
        <strong>{statsContent.didYouKnow}</strong>
        <br />
        {statsContent.secondStat}
      </p>
      <img src={People} alt="" />
    </Stat>

    <Stat hasImage>
      <p data-testid="average-usage-stat">
        <strong>{statsContent.didYouKnow}</strong>
        <br />
        {statsContent.thirdStat}
      </p>
      <img src={SIM} alt="" />
    </Stat>
  </Wrapper>
)

export default DataRolloverStats
